/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Hightemperaturereturntemperature3Inputs */



/**
* | output |
* | --- |
* | "High temperature return temperature" |
*
* @param {Br_History_Key_Hightemperaturereturntemperature3Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_hightemperaturereturntemperature3 = /** @type {((inputs?: Br_History_Key_Hightemperaturereturntemperature3Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Hightemperaturereturntemperature3Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("High temperature return temperature")
	return /** @type {LocalizedString} */ ("Température retour haute température")
});
export { br_history_key_hightemperaturereturntemperature3 as "br_history_key_highTemperatureReturnTemperature" }